<template>
	<v-dialog v-model="dialog" v-bind="$attrs" scrollable>
		<v-card>
			<v-card-title>
				<span>Notes</span>
				<v-spacer></v-spacer>
				<v-btn icon @click="dialog = false"><v-icon>fa-close</v-icon></v-btn>
			</v-card-title>
			<v-card-text>
				<!-- TODO add loadMore btn if more comments are available -->
				<div class="fill-width text-center">
					<v-progress-circular v-if="loadingNotes" indeterminate />
					<span v-else-if="!notes.length">
						No notes yet for this alarm.
					</span>
				</div>
				<v-card
					v-for="note in notes"
					:key="'note-' + note.id"
					class="my-1"
					elevation="0"
					outlined
				>
					<v-card-title class="subtitle-2">
						<span> {{ note.updated_by }} - {{ note.action_type }} </span>
					</v-card-title>
					<v-card-subtitle class="overline">
						<span>
							{{ fullDateTime(note.ts) }}
						</span>
					</v-card-subtitle>
					<v-card-text v-if="note.comments">{{ note.comments }}</v-card-text>
				</v-card>
				<div ref="lastItem"></div>
			</v-card-text>
			<v-card-actions>
				<v-form
					class="d-flex fill-width align-end"
					@submit.prevent="addComments"
				>
					<v-textarea
						v-model="comments"
						class="pt-0 mt-0"
						label="Add notes"
						rows="2"
						counter="250"
						single-line
						:disabled="loading"
					></v-textarea>
					<v-btn
						id="send-btn"
						class="mb-4"
						text
						color="ocean"
						type="submit"
						:disabled="loading || !comments || comments.length > 250"
						><v-icon>fa-paper-plane</v-icon></v-btn
					>
				</v-form>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { fullDateTime } from "@/utils/dateHelpers";

export default {
	data() {
		return {
			dialog: false,
			comments: "",
			loading: false,
		};
	},

	computed: {
		...mapGetters("tickets/fixWizard", ["notes", "loadingNotes"]),
	},

	created() {
		this.fetchNotes();
	},

	methods: {
		...mapActions("tickets/fixWizard", ["getNotes", "logAction"]),
		fullDateTime,

		pop() {
			this.dialog = true;
			this.$nextTick(() => this.scrollToBottom());
			this.fetchNotes();
		},

		async fetchNotes() {
			await this.getNotes();
			this.scrollToBottom();
		},

		scrollToBottom() {
			if (this.$refs.lastItem) {
				this.$refs.lastItem.scrollIntoView();
			}
		},

		async addComments() {
			if (this.loading) return;
			this.loading = true;
			try {
				const note = await this.logAction(this.comments);
				this.$store.commit("tickets/fixWizard/setNotes", [note, ...this.notes]);
				this.comments = "";
				await this.fetchNotes();
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#send-btn {
	min-width: 36px;
	padding: 0;
}
</style>
